import { lazy } from "react";
import { circleEditOutlineSVG } from '../shared/helpers/icons';

const EntryPoint = lazy(() => import(/* webpackChunkName: "gpsSearch" */ './components/EntryPoint'));
const GpsSearchLoader = lazy(() => import(/* webpackChunkName: "gpsSearchLoader" */ './components/GpsSearchLoader'));

export const defaultPath = '/gps-search';

export const innerRoutes = [
    {
        path: `${defaultPath}/`,
        Component: GpsSearchLoader,
        exact: true,
        icon: circleEditOutlineSVG,
        title: {
            key: 'Buscar y Editar',
            plural: false
        },
        subTitle: {
            key: 'Busca GPSs o Simcards para cambiarlos de estado',
            plural: false
        }
    }
];

const gpsSearch = {
    path: defaultPath,
    Component: EntryPoint,
    exact: false,
    icon: circleEditOutlineSVG,
    title: {
        key: 'Buscar y Editar',
        plural: false
    },
    subTitle: {
        key: 'Busca GPSs o Simcards para cambiarlos de estado',
        plural: false
    },
    order: 1,
    innerRoutes
};

export default gpsSearch;
